<template>
  <div>
    <div
      v-if="value"      
      class="file-uploader-preview">
      <p
        class="file-uploader-preview__delete"
        :class="{'file-uploader-preview__delete--image': fileTypeIsImage}"
        @click="onClickImageDelete">
        <b-icon-x-circle-fill />
      </p>
      <img
        v-if="fileTypeIsImage"
        :src="imagePreview"
        class="file-uploader-preview__img">
      <div
        v-else
        class="file-uploader-preview__file">
        <img
          src="@/assets/images/file-icon.svg"
          class="mr-2">
        <span>{{ fileName }}</span>
      </div>
    </div>
    
    <label
      v-if="!value"
      style="cursor: pointer;">
      <b-form-file
        class="d-none"
        :value="value"
        placeholder="ファイルを選択"
        browse-text="選択"
        accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx"
        @input="onInputFile" />
      <img
        src="@/assets/images/file-icon.svg"
        class="file-uploader-icon">
    </label>
  </div>
</template>

<script>
import loadImage from 'blueimp-load-image'

export default {
  props: {
    value: {
      type: [String, File],
      default: null
    },
    filename: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      localThumbnail: null,
      rawFile: null,
      pngMIME: 'image/png'
    }
  },
  computed: {
    fileTypeIsImage() {
      if (!this.value) return false
      if (this.fileIsURL) {
        const images = ['jpg', 'jpeg', 'png']
        return !!images.find(i => i === this.fileExtension)
      } 
      return this.value.type.includes('image')
    },
    fileIsURL() {
      try {
        const url = new URL(this.value)
        return !!url
      } catch {
        return false
      }
    },
    fileName() {
      if (!this.value) return ''
      if (this.filename) return this.filename
      if (this.fileIsURL) {
        const decoded = decodeURI(this.value)
        return decoded.split('?')[0].split('/').pop()
      } 
      return this.value.name
    },
    fileExtension() {
      if (this.fileIsURL) {
        return this.value.split('?')[0].split('.').pop().trim()
      }
      return ''
    },
    imagePreview() {
      if (this.fileIsURL) return this.value
      return this.localThumbnail
    },
  },
  methods: {
    // TODO 他のもあとで正規表現で書き直す
    isCorrectExtension(filename) {
      const format = new RegExp('([^\\s]+(\\.(jpg|jpeg|png))$)', 'i')
      return format.test(filename)
    },
    onInputFile(file) {
      this.rawFile = file
      if (!this.rawFile) return
      this.$emit('input', this.rawFile)
      // 画像ファイルの場合は、プレビュー画像(localThumbnail)を正しく表示するためにcanvasで向き補正したものを書き出す
      if (this.isCorrectExtension(this.rawFile.name)) {
        loadImage.parseMetaData(this.rawFile, data => {
          const options = {
            // imageSmoothingQuality: 'high',
            maxWidth: 500,
            maxHeight: 500,
            canvas: true // canvas にリサイズ後の写真を書出す為必要
          }
          if (data.exif) {
            options.orientation = data.exif.get('Orientation')
          }
          loadImage(
            this.rawFile,
            (canvas) => {
              this.localThumbnail = canvas.toDataURL(this.rawFile.type)
            },
            options
          )
        })
      } else {
        this.localThumbnail = null
      }
    },
    onClickImageDelete() {
      this.$emit('input', null)
      this.rawFile = null
      this.localThumbnail = null
    },
  }
}
</script>

<style lang="scss" scoped>
.file-uploader-preview {
  position: relative;
  &__delete {
    width: 24px;
    position: absolute;
    top: -16px;
    right: -13px;
    font-size: 18px;
    cursor: pointer;
    &--image {
      left: 141px;
    }
  }
  &__file {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: $white;
  }
  &__img {
    object-fit: cover;
    width: 150px;
    border: 1px solid $white;
    box-sizing: border-box;
  }
}

.file-uploader-icon {
  width: 40px;
  height: 40px;
  background: $white;
  border-radius: 50%;
  padding: 6px;
}
</style>